/* (ignored) */


//////////////////
// WEBPACK FOOTER
// url (ignored)
// module id = 706
// module chunks = 0